/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Session_DetailInputs */

const en_portal_week_session_detail = /** @type {(inputs: Portal_Week_Session_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18:00 · room 2`)
};

const pl_portal_week_session_detail = /** @type {(inputs: Portal_Week_Session_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18:00 · sala 2`)
};

/**
* | output |
* | --- |
* | "18:00 · room 2" |
*
* @param {Portal_Week_Session_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_session_detail = /** @type {((inputs?: Portal_Week_Session_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Session_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_session_detail(inputs)
	return en_portal_week_session_detail(inputs)
});